import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    const isChunkError = error.name === 'ChunkLoadError' || 
      (error.message && error.message.includes('Loading chunk'));
    return { hasError: true, isChunkError };
  }

  componentDidCatch(error, errorInfo) {
    // If a chunk fails to load, it usually means a new version was deployed.
    // Reloading the page forces the browser to fetch the latest index.html and chunks.
    if (this.state.isChunkError) {
      // Use sessionStorage to prevent infinite reload loops if the chunk is genuinely missing
      const isReloading = sessionStorage.getItem('chunk_error_reloading');
      if (!isReloading) {
        sessionStorage.setItem('chunk_error_reloading', 'true');
        window.location.reload();
      } else {
        // Clear the flag so that future errors can try to reload again
        sessionStorage.removeItem('chunk_error_reloading');
      }
    } else {
      console.error("Uncaught error:", error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.state.isChunkError) {
        return (
          <div className="min-h-[60vh] flex flex-col items-center justify-center p-4 text-center">
            <h2 className="text-xl font-semibold mb-2">A new version is available</h2>
            <p className="text-muted-foreground mb-4">
              We've encountered an issue loading this page. This usually happens when the application has been updated.
            </p>
            <button 
              onClick={() => {
                sessionStorage.removeItem('chunk_error_reloading');
                window.location.reload();
              }}
              className="px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm font-medium hover:opacity-90"
            >
              Refresh Page
            </button>
          </div>
        );
      } else {
        return (
          <div className="min-h-[60vh] flex flex-col items-center justify-center p-4 text-center">
            <h2 className="text-xl font-semibold mb-2 text-destructive">Something went wrong</h2>
            <p className="text-muted-foreground mb-4">
              An unexpected error occurred. Please try refreshing the page.
            </p>
            <button 
              onClick={() => window.location.reload()}
              className="px-4 py-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground text-foreground rounded-md text-sm font-medium"
            >
              Refresh Page
            </button>
          </div>
        );
      }
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
